import React, { useEffect, useState } from "react";
import "../styles/BloggerPage.css";
import bhrigu_logo from "../assets/images/bhrigu-logo.gif";
import config from "../services/config";
import Loader from "../utilities/Loader";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function PicArt() {
    const navigate = useNavigate();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const bloggerId = query.get("id");
    const bloggerTitle = query.get("title");
    const [blogger, setBlogger] = useState([]); // ✅ initialize as empty array
    const [loading, setLoading] = useState(false);

     useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
          navigate("/");
        }
      }, [navigate]);

    const fetchBloggerDetailsData = async () => {
        try {
            setLoading(true);
            const payload = { id: bloggerId };

            const Res = await config.getBlogById(payload);
            console.log("Res", Res.data);

            if (Res?.status === true && Array.isArray(Res.data)) {
                setBlogger(Res.data); // ✅ always expect array
            } else if (Res?.status === true && Res.data) {
                // in case API returns single object
                setBlogger(Res.data);
            } else {
                setBlogger([]); // fallback empty array
            }
        } catch (error) {
            console.error("❌ Error fetching blogger data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (bloggerId) {
            fetchBloggerDetailsData();
        }
    }, [bloggerId]);

    if (loading) return <Loader />;
    if (!bloggerId) return <div>No blogger selected.</div>;

    return (
        <section className="mainsection">
            <div className="container-fluid">
                {/* Logo + Title */}
                <div className="row">
                    <div className="col-lg-2 col-md-2 col-4">
                        <img src={bhrigu_logo} alt="logo" className="img-fluid custom-logo" />
                    </div>
                    <div className="col-lg-10 col-md-10 col-8">
                        <h1>{bloggerTitle}</h1>
                    </div>
                </div>

                {/* Profile + Content */}
                <div className="row mainContentBlog">
                    {/* Left Panel */}
                    <div className="leftPanelBlog">
                        <div className="profileImageContainer"><img
                            src={blogger.image_path}
                            alt={blogger.blogger_name}
                            className="profile-img"
                        />
                        </div>

                        <div className="profileAuthorTitle">
                            <h3>{blogger?.blogger_name}</h3>
                        </div>

                        <div className="profileDetailsContainer">
                            <p>
                                {blogger?.blogger_about}
                            </p>
                        </div>
                    </div>

                    {/* Right Content Panel */}
                    <div className="col-md-10 rightPanelBlog">
                        <div className="blogContentContainer">
                           <p>
  {new DOMParser()
    .parseFromString(blogger?.about_blogger || "", "text/html")
    .body.textContent}
</p>

                            {/* <p>
                "नागण फुसन" संभवतः नागणेची माता (या नागणेच्या मां) के लिए एक गलत वर्तनी है, 
                जो राठौड़ वंश की कुलदेवी हैं। वे मारवाड़ और बीकानेर राज्यों की कुलदेवी हैं...
              </p>

              <p>
                "नागण फुसन" संभवतः नागणेची माता (या नागणेच्या मां) के लिए एक गलत वर्तनी है...
              </p>

              <p>
                "नागण फुसन" संभवतः नागणेची माता (या नागणेच्या मां) के लिए एक गलत वर्तनी है...
              </p> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}